import React from 'react';
import { ChoiceButton, OptionButton } from './Buttons';


const CourseTableRow = (props) => {
    const { 
        choice,
        leftovers,
        onSelectionChanged
    } = props;

    let choiceButton;

    if (choice) {
        choiceButton = <ChoiceButton
            name={choice}
            handleClick={() => onSelectionChanged(null)} />
    } else {
        choiceButton = <ChoiceButton
            name="-"
            handleClick={() => null} />;
    }

    return (
        <tr>
            <td style={{width: 64+'px'}}>
                <div className="buttonlist">
                    {choiceButton}
                </div>
            </td>
            <td>
                <div className="buttonlist">
                    {
                        leftovers.map((option) => {
                            return (
                                <OptionButton 
                                    key={option}
                                    name={option}
                                    handleClick={() => onSelectionChanged(option)} />
                            );
                        })
                    }
                </div>
            </td>
        </tr>
    );
}


export default CourseTableRow;